module.exports = "<div class=\"gw-alert\" ng-class=\"'gw-alert_type_' + (type || 'info')\">\r\n    <i class=\"gw-alert__icon\" ng-class=\"icon()\"></i>\r\n    <div class=\"gw-alert__content\" ng-transclude></div>\r\n    <button ng-if=\"closeable\" type=\"button\" class=\"gw-alert__close\" ng-click=\"close()\">\r\n        <span aria-hidden=\"true\">&times;</span>\r\n    </button>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./app/customer/js/src/edge/platform/widgets/inputs/templates/alert.html
// module id = 408
// module chunks = 0